import { FormControl, FormLabel } from '@mui/material';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import React, { HTMLInputTypeAttribute } from 'react';

interface InputComLabelProps {
  valor: string;
  setValor: (valor: string) => void;
  labelTexto: string;
  placeholder?: string;
  width?: string;
  type?: HTMLInputTypeAttribute;
  required?: boolean;
  maxLength?: number;
  version?: 'primary' | 'secondary';
}
const InputComLabel: React.FC<InputComLabelProps> = ({
  valor,
  setValor,
  labelTexto,
  placeholder = '',
  width = '100%',
  type = 'text',
  maxLength = 200,
  required = false,
  version = 'secondary',
}) => {
  // Rótulo que será exibido acima do campo
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (type === 'number') {
      event.target.value = event.target.value.replace(/[^0-9]/g, '');

      if (parseInt(event.target.value) < 0) {
        event.target.value = '0';
      }
    }
    setValor(event.target.value);
  };

  return (
    <>
      {version === 'primary' ? (
        <Box sx={{ width: width }}>
          <TextField
            id='beneficiarios-exclusivamente-municipio'
            label={labelTexto}
            variant='outlined'
            placeholder={placeholder}
            type={type}
            required={required}
            value={valor}
            onChange={handleChange}
            inputProps={{
              maxLength: maxLength,
            }}
            InputLabelProps={{
              shrink: true,
            }}
            sx={{
              width: '100%',
            }}
          />
        </Box>
      ) : (
        <FormControl
          sx={{
            width: width,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
          }}
        >
          <FormLabel
            id='foreigner-label'
            sx={{
              color: '#333',
              fontWeight: 'bold',
            }}
          >
            {required && (
              <span
                style={{ color: 'red', fontSize: '15px', marginRight: '4px' }}
              >
                *
              </span>
            )}
            {labelTexto}
          </FormLabel>

          <TextField
            id='beneficiarios-exclusivamente-municipio'
            variant='outlined'
            type={type === 'number' ? 'text' : type}
            required={required}
            value={valor}
            inputProps={{ maxLength: maxLength }}
            onChange={handleChange}
            placeholder={placeholder}
          />
        </FormControl>
      )}
    </>
  );
};

export default InputComLabel;
